"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AutoCompleteContainer_1 = __importDefault(require("./AutoCompleteContainer"));
var functions_1 = require("../functions");
function AutoCompleteWithResultsAndValues(props) {
    var initNameValueResults = props.initNameValueResults, autoCompleteWithResultsAndValuesRef = props.autoCompleteWithResultsAndValuesRef;
    var _a = functions_1.useSearchInput(__assign(__assign({}, props), { ref: autoCompleteWithResultsAndValuesRef })), nameValueResults = _a.nameValueResults, nameResultList = _a.nameResultList, setNameValueResult = _a.setNameValueResult, handleChangeValuesByInput = _a.handleChangeValuesByInput;
    var names = Object.keys(initNameValueResults);
    return (react_1.default.createElement(react_1.default.Fragment, null, names.map(function (name, i) {
        var valueResult = nameValueResults[name];
        var valueResultList = nameResultList[name];
        var handleSetValue = setNameValueResult(name);
        var handleChange = handleChangeValuesByInput(name);
        return (react_1.default.createElement(AutoCompleteContainer_1.default, __assign({ key: name }, valueResult, { onChange: handleChange, setValueFn: handleSetValue, valueResultList: valueResultList })));
    })));
}
;
exports.default = AutoCompleteWithResultsAndValues;
